import { POST, GET, productURL } from '@/http/api.js'

// 列表   ft   138
const tenantdictlist = (params) => POST("/ft/finance/config/tenantdictlist", params);
// 详情
const tenantdictdetail = (params) => GET("/ft/finance/config/tenantdictdetail", params);
// 保存/文件启用   102
const submit = (params) => POST("/ft/finance/config/submit", params);
//提交审核
const subAudit = (params) => GET("/ft/finance/config/audit", params);
// 详情
const dictionarylist = (params) => GET("/ft/finance/config/dictionarylist", params);
// 停用启用
const confirm = (params) => POST("/ft/finance/param/operator/confirm", params)
// 导出
const productExport = productURL + "/product/list/export";

// http://128.192.182.163/scm/bds/privaters/image/upload    http://128.192.182.163/scm/bds/publicrs/image/upload
// 上传
const uploadimg = (params) => UPLOAD("/bds/publicrs/image/upload", params)
// 已上传的资质文件图片
const companyAuthFiles = (params) => POST("/ft/finance/qualification/companyAuthFiles", params)

// ?
// 流水号
const serialNoGen = (params) => GET("/usr/serialNoGen", params);
export {
    tenantdictlist,
    tenantdictdetail,
    submit,
    subAudit,
    dictionarylist,
    confirm,
    uploadimg,
    companyAuthFiles,
    serialNoGen,
}